<template>
  <div>
    <el-dialog
      title="各平台KEY列表"
      v-model="dialogVisible"
      width="50%"
      top="5vh"
    >
      <div class="container" style="height: 600px; margin-left: -10px">
        <fieldset>
          <legend>KEY安装指导说明</legend>
          为保证您使用的KEY可以正常登录测绘测绘地理信息服务管理平台系统，请下载并安装对应的KEY驱动程序，屏幕分辨率建议调整为1024×768或以上。
        </fieldset>

        <table class="key-table">
          <tbody>
            <tr>
              <td colspan="4" class="title">Windows操作系统安装驱动</td>
            </tr>
            <tr>
              <td>序号</td>
              <td>操作系统</td>
              <td>CPU型号</td>
              <td>操作</td>
            </tr>
            <tr>
              <td>1</td>
              <td>Windows操作系统（Windows7及以上）</td>
              <td>AMD、Intel处理器等</td>
              <td>
                <a
                  class="link-download-key"
                  href="/static/libs/et99/ET99驱动.zip"
                  download="ET99驱动"
                  target="_self"
                  >下载驱动</a
                >
              </td>
            </tr>
            <tr>
              <td colspan="4" class="title">国产化平台安装驱动</td>
            </tr>
            <tr>
              <td>序号</td>
              <td>CPU架构</td>
              <td>主流CPU型号</td>
              <td>操作</td>
            </tr>
            <tr>
              <td>1</td>
              <td>loongarch64</td>
              <td>龙芯3A5000</td>
              <td>
                <a
                  class="link-download-key"
                  href="/static/libs/et99/et99_longxin_loongarch64.rar"
                  download="et99_longxin_loongarch64.rar"
                  target="_self"
                  >下载驱动</a
                >
              </td>
            </tr>
            <tr>
              <td>2</td>
              <td>ARM64</td>
              <td>飞腾、鲲鹏、海思麒麟</td>
              <td>
                <a
                  class="link-download-key"
                  href="/static/libs/et99/et99_qilin_arm64.rar"
                  download="et99_qilin_arm64.rar"
                  target="_self"
                  >下载驱动</a
                >
              </td>
            </tr>
            <tr>
              <td>3</td>
              <td>X86</td>
              <td>兆芯、海光</td>
              <td>
                <a
                  class="link-download-key"
                  href="/static/libs/et99/et99_haiguang_amd64.rar"
                  download="et99_haiguang_amd64.rar"
                  target="_self"
                  >下载驱动</a
                >
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <p style="font-size: 18px; margin: 20px 0 0 2%">
            《国产化平台CPU架构查询说明.docx》
            <a
              class="link-this"
              href="/static/libs/et99/国产化系统CPU查询说明.docx"
              download="国产化系统CPU查询说明.docx"
              target="_self"
              >点击此处</a
            >
            下载
          </p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "KeysDialog",
  data() {
    return {
      dialogVisible: false,
    };
  },
  methods: {
    showDialog() {
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 8px;
}

.key-table {
  margin-top: 8px;
  width: 100%;

  td {
    text-align: center;
    line-height: 26px;
    font-size: 14px;
    padding: 10px;
    letter-spacing: 1px;
    border: 1px solid #ccc;

    &.title {
      background-color: #fbfbfd;
    }

    a {
      color: blue;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}

p {
  a {
    color: blue;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
